/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_HighlightsInputs */

const vi_shop_group_highlights = /** @type {(inputs: Shop_Group_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm nổi bật`)
};

/**

* @param {Shop_Group_HighlightsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_highlights = /** @type {((inputs?: Shop_Group_HighlightsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_HighlightsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_highlights(inputs)
});